<template>
    <div>
        <div @click="showContext = !showContext" ref="contextButton" class="messages-item-context-opener"
            :class="{ 'open': showContext }"></div>
        <div v-if="showContext" v-click-outside="{
            exclude: ['contextButton'],
            handler: 'clickOutsideContext'
        }" class="messages-item-context">
            <div v-if="!my" @click="complain(id)" class="messages-item-context-item">{{ $t("vipbuy.markSpam") }}</div>
            <div @click="deleteMessage(id)" class="messages-item-context-item" :class="{ 'button-loader': deleteLoader }">
                {{ $t("myPuzzles.delete") }}</div>
        </div>
    </div>
</template>

<script>
import redirectButton from '@/components/Buttons/Redirect';
import { clickOutside } from '@/directives.js';

export default {
    name: 'MessageContext',
    props: {
        i18n: Object,
    },
    props: {
        id: {
            type: Number,
            required: true
        },
        my: {
            type: Boolean,
            required: true
        }
    },
    components: {
        redirectButton
    },
    data() {
        return {
            showContext: false,
            deleteLoader: false
        }
    },
    methods: {
        complain(id) {
            this.$modal.show('dialog', {
                title: this.$t("vipbuy.itSpam"),
                text: this.$t("vipbuy.markAsSpam"),
                buttons: [
                    {
                        title: this.$t("vipbuy.yes"),
                        handler: () => {
                            this.$modal.hide('dialog');
                            this.$store.dispatch('messages/setSpam', id)
                                .then(() => {
                                    this.showContext = false;
                                    this.$modal.show('dialog', {
                                        title: this.$t("threads.success"),
                                        text: this.$t("vipbuy.yourSpamMessage"),
                                        buttons: [
                                            { title: this.$t("roulette.ok") }
                                        ]
                                    });
                                });
                        }
                    },
                    {
                        title: this.$t("threads.cancel"),
                        handler: () => {
                            this.$modal.hide('dialog');
                            this.showContext = false;
                        }
                    }
                ]
            })
        },
        deleteMessage(id) {
            this.deleteLoader = true;
            this.$store.dispatch('messages/deleteMessage', id)
                .then(() => {
                    this.deleteLoader = false;
                    this.showContext = false;
                })
                .catch(() => {
                    this.deleteLoader = false;
                    this.showContext = false;
                });
        },
        clickOutsideContext() {
            this.showContext = false;
        }
    }
}
</script>
